<template>


    <div class="w-full sm:w-1/2 md:w-1/3 flex flex-col p-3">
       <div class="bg-white rounded-lg shadow-lg overflow-hidden flex w-full" style="flex-grow: 1; flex-shrink: 0; flex-basis: auto;">
            <div class="p-4 flex flex-1 flex-col w-full" style="">
                <h3 class="mb-2 text-base md:text-lg font-semibold text-gray-900">{{ card.title }}</h3>
                <div class="text-gray-800 text-sm" style="flex-grow: 1; flex-shrink: 0; flex-basis: auto;">
                    <p class="text-sm lg:text-base" :class="card.tags ? 'pb-3' : ''" style="flex-grow: 1; flex-shrink: 0; flex-basis: auto;">{{ card.content }}</p>
                </div>
                <div v-if="card.tags" class="flex flex-wrap justify-center border-t border-gray-400 pt-2">
                    <div v-for="(tag, index) in card.tags" :key="index"
                        class="bg-gray-500 text-white p-1 px-3 mx-1 mt-2 rounded-full text-xs"
                    >{{ tag }}</div>
                </div>
            </div>
        </div>
    </div>



<!--

References for card layout:

 - https://clearleft.com/posts/an-equal-height-grid-using-flexbox
 - https://css-tricks.com/fluid-width-equal-height-columns/
 - https://codepen.io/codetimeio/pen/RYMEJe
 - https://stackoverflow.com/questions/38231141/flexbox-not-working-on-safari-9-1-1

-->



</template>

<script>
export default {
    props: [ 'card' ],
}
</script>
